const salary = {
    getlist: 'salary/getlist',
    add: 'salary/add',
    update: 'salary/update',
    remove: 'salary/remove',
    get: 'salary/get',
    getall: 'salary/getall',
    clearcache: 'salary/clear-cache',
}
export default salary
